import React, { Component } from 'react';
import './JobNew.scss';
import { base, newJob, statuses } from '../../../config'
import { objCleaner } from '../../helpers'
import moment from 'moment'
import DatePicker from 'react-16-bootstrap-date-picker'
import DateForm from '../DateForm'
import { browserHistory } from 'react-router'
import * as _ from 'lodash'

const schema = {
  type: "object",
  required: ["label", "z_customer_email", "start", "end"],
  properties: {
    label: { type: "string", title: "Job Name" },
    start: { type: "string", format: "date", title: "Start Date", default: moment(new Date()).format("YYYY-MM-DD")  },
    end: { type: "string", format: "date", title: "End Date", default: moment(new Date()).format("YYYY-MM-DD")  },
    discount: { type: "string", title: "Discount %", default: '0' },
    vat: { type: "string", title: "VAT %", default: '0' },
    address: {
      type: "object",
      title: "Customer Details",
      properties: {
        client_name: {type: "string",title: "Name", default: ""},
        z_customer_email: { type: "string", title: "Email", default: ''},
        tel: { type: "string", title: "Phone Number", default: ''},
        address_1: {type: "string", title: "Address", default: ""},
        city: {type: "string", title: "City", default: ""},
        postcode: {type: "string",title: "Postcode", default: ""}
      }
    },
    selected_status: {
      type: "object",
      properties: {
        label: {type: "string", default: "Creating Quote"},
        value: {type: "string", default: "quote"}
      }
    },
    total: {
      type: "object",
      properties: {
        cost: {type: "string", default: "0"},
        sale: {type: "string", default: "0"}
      }
    }
  }
}

import Form from "react-jsonschema-form"
import {Link} from 'react-router'

class JobNew extends Component {

    constructor(props) {
        super(props);
        this.state = {
          formData: {},
          default: null
        }
        this._new = this._new.bind(this)
        this._changeTotal = _.debounce(this._changeTotal, 500)
    }

    _changeTotal () {
      this._new()
    }

    _new () {
      const {formData} = this.state
      if (!formData.label) {
        alert('Please give a label for this job')
        return
      }

      if (new Date(formData.start) > new Date(formData.end)) {
        alert('The end date for this job must be after the sart date')
        return
      }

      const _this = this
      let newJobFace = this.state.formData
      newJobFace.selected_status = statuses[0]
      if (this.props.job) {
        base.update(`user_details/${this.props.uid}/jobs/${this.props.jobId}`, {
          data: this.state.formData,
          then () {
            _this.props.finsihed()
            _this.props.notify('Job Saved', 1, 'success')
          }
        })
      } else {
        // Create new Job
        const immediatelyAvailableReference = base.push(`user_details/${this.props.uid}/jobs`, {
          data: newJobFace
        })
        const generatedKey = immediatelyAvailableReference.key

        base.post(`user_details/${this.props.uid}/sheets/${generatedKey}`, {
          data: newJob,
          then () {
            //browserHistory.push(`/job/${generatedKey}`)
          }
        })

        base.post(`user_details/${this.props.uid}/plan/${generatedKey}`, {
          data: [
            {
              name: 'Expenses',
              items: []
            }
          ],
          then () {
            browserHistory.push(`/job/${generatedKey}/tabs-view`)
          }
        })

        // If default available
        // this.ref = base.fetch(`user_details/${this.props.uid}/default`, {
        //   context: this,
        //   then(data){
        //     if (_.isEmpty(data)) {
        //       base.post(`user_details/${this.props.uid}/sheets/${generatedKey}`, {
        //         data: newJob,
        //         then () {
        //           browserHistory.push(`/job/${generatedKey}`)
        //         }
        //       })
        //     } else {
        //       base.post(`user_details/${this.props.uid}/sheets/${generatedKey}`, {
        //         data: data,
        //         then () {
        //           browserHistory.push(`/job/${generatedKey}`)
        //         }
        //       })
        //     }
        //   }
        // })
      }
    }

    componentDidMount () {
      if (this.props.job) {
        this.setState({
          formData: this.props.job
        })
      }
    }

    componentDidUpdate (preProps) {
      if (!_.isEqual(this.props.job, preProps.job)) {
        this.setState({
          formData: this.props.job
        })
      }
    }

    _change (event) {
      this.setState({
        formData: event.formData
      })
      if (this.props.edit) this._changeTotal()
    }

    render() {

        const clas = this.props.edit ? 'col-sm-12' : 'col-sm-12'

        const schemaUi = {
          label: { "classNames": 'col-md-12', "ui:placeholder": "Name", "ui:options": { "label": true }},
          z_customer_email: { "classNames": 'col-md-12', "ui:placeholder": "email@domain.com"},
          start: { "classNames": clas, "ui:field": "date"},
          end: { "classNames": clas, "ui:field": "date"},
          address: { "classNames": 'col-sm-12'},
          discount: { "classNames": 'col-sm-6'},
          vat: { "classNames": 'col-sm-6'},
          selected_status: {"classNames": "hidden"},
          total: {"classNames": "hidden"}
        }

        const saveBtn = this.props.edit ? "Save" : "Create Job &nbsp;<i className='glyphicon glyphicon-plus' />"

        return (
            <div className='job-new '>

                <div className='panel panel-info'>
                  <div className='panel-heading'>
                    Create New Job
                  </div>
                  <div className='panel-body'>
                    <div className="row">
                      <Form
                        formData={this.state.formData}
                        schema={schema}
                        uiSchema={schemaUi}
                        fields={{date: DateForm}}
                        onChange={this._change.bind(this)}
                        onSubmit={this._new}
                      />
                    </div>
                  </div>
                  <div className="panel-footer">
                    <div className='row'>
                      <div className='col-xs-5 '>
                        <Link className=' btn pull btn- btn-danger btn-block' onClick={this.props.newJob}>
                          Cancel
                        </Link>
                      </div>
                      <div className='col-xs-7'>
                        <Link className='btn pull btn- btn-success btn-block' onClick={this._new.bind(this)}>
                          <span dangerouslySetInnerHTML={{__html: saveBtn}}></span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

            </div>
        )
    }
}

export default JobNew;



// WEBPACK FOOTER //
// ./src/views/components/JobNew/index.js